export const validateTransferLabel = (label: string): boolean => {
  // Matches unicode characters between index 32 and index 126
  // (first 128 characters without control characters)
  // see https://en.wikipedia.org/wiki/Basic_Latin_(Unicode_block)#Block
  // Other unicode characters weight more than 1 byte
  // which breaks the 140 characters (bytes) limit on Treezor side
  const regex = /^[\x20-\x7E]*$/;

  return regex.test(label);
};

export const formatAmount = (
  amount: number,
  lang: string,
  withDecimals = true,
) =>
  (withDecimals ? amount : Math.trunc(amount)).toLocaleString(lang, {
    maximumFractionDigits: withDecimals ? 2 : 0,
    minimumFractionDigits: withDecimals ? 2 : 0,
  });

const NUMBER_WITH_GROUP_AND_DECIMAL_SEPARATOR = 1000.1;
const getFormattedAmountSeparator = (
  formatter: Intl.NumberFormat,
  separatorType: 'group' | 'decimal',
) =>
  formatter
    .formatToParts(NUMBER_WITH_GROUP_AND_DECIMAL_SEPARATOR)
    .find((part) => part.type === separatorType)?.value;

const getFormattedAmountSeparators = (lang: string) => {
  const formatter = Intl.NumberFormat(lang);

  return {
    decimalSeparator: getFormattedAmountSeparator(formatter, 'decimal'),
    groupSeparator: getFormattedAmountSeparator(formatter, 'group'),
  };
};

export const parseAmount = (
  amount: string | number | undefined,
  lang: string,
): number | undefined => {
  if (amount === '' || amount === undefined) {
    return undefined;
  }
  if (typeof amount === 'number') {
    return amount;
  }

  let unformattedAmountString = amount.replace(/\s/g, '');
  const separators = getFormattedAmountSeparators(lang);
  if (separators.groupSeparator) {
    unformattedAmountString = unformattedAmountString
      .split(separators.groupSeparator)
      .join('');
  }
  if (separators.decimalSeparator) {
    unformattedAmountString = unformattedAmountString
      .split(separators.decimalSeparator)
      .join('.');
  }

  return parseFloat(unformattedAmountString) || undefined;
};
